module.exports = __webpack_public_path__ + "static/media/loader.346f7dc6.gif";